<template>
	<footer class="row footer py-3">            
        <div class="col-12 col-md-2 text-center logo_footer">
            <a href="/">
                <img src="/assets/images/logo.png" alt="Mộc game" width="100px" class="img-fluid">
            </a>
        </div>
        <div class="col-12 col-md-8 text-center">
            <p><router-link :to="{name: 'ProvisionComponent'}">Điều khoản</router-link> | <router-link :to="{name: 'SecurityComponent'}">Bảo mật</router-link></p>


			<p>Email: cskh@mocgame.vn</p>


			<p>Giấy phép cung cấp dịch vụ trò chơi điện tử G1 trên mạng số 190/GP-PTTH&TTĐT do Cục Phát thanh, Truyền hình và Thông tin điện tử cấp ngày 02/12/2025</p>

			<p>Địa chỉ: Tầng 3, Tòa nhà An Phú Plaza, 117-119 Lý Chính Thắng, Phường Võ Thị Sáu, Quận 3, Thành phố Hồ Chí Minh, Việt Nam</p>
        </div>
        <div class="col-12 col-md-2 text-center">
            <img src="/assets/images/18plus.png" alt="Trên 18 tuổi" width="60px" class="img-fluid">
        </div>
    
	</footer>
   
</template>

<script>
    export default {
        name: "FooterComponent"
    }
</script>

<style scoped>

</style>
